<template>
	<div class="keyboards">
		<div class="call_num">
			<el-input placeholder="" v-model="callNum" @input="allNumber"></el-input>
      <!-- delete num button start  -->
      <div class="btn_box backspace" v-show="callNum.length" @click="callNum = callNum.substring(0, callNum.length - 1)">
        <font-awesome-icon :icon="['fas', 'delete-left']" />
      </div>
      <!-- delete num button end  -->
		</div>
    <div class="num_box">
      <div class="num" v-for="num in keyboardsList" :key="num.label" @click="clickNum(num)">
        <div class="num_label">{{ num.label }}</div>
        <div class="num_descr">{{ num.label == '1' ? '&nbsp;' : num.descr }}</div>
      </div>
    </div>
    <!--show call button if userinfo pannel is not show  -->
    <div class="call_btns" v-if="showCallBtn == 1 && !callStatus">
      <div class="call_start btn_box" @click="createCall">
        <font-awesome-icon :icon="['fas', 'phone']"/>
      </div>
     </div> 
	</div>
</template>

<script>
import { keyboardsList } from './keyboardsList'
export default {
	name: "keyboards",
  props: ["showCallBtn","callStatus"],
  computed:{
    sipLang() {
			return this.$SIP.getLangText();
		},
  },
  data(){
    return {
      callNum: "",
      keyboardsList
    }
  },
  created(){
    // Dashboardではstore_svがないため、条件付きで処理
    if(this.$store.state.store_sv && this.$store.state.store_sv.sv_help_onSupportFlg && this.$store.state.store_sv.sv_helper_info && this.$store.state.store_sv.sv_helper_info.svExtension && this.showCallBtn == 2) {
      this.callNum = this.$store.state.store_sv.sv_helper_info.svExtension
    }
  },  
  methods:{
    allNumber(val) {
      this.callNum = val.replace(/[^\d]/g, '')
    },
    clickNum(num) {
      if(this.showCallBtn == 0) {
        if(this.callStatus){
          this.callNum = `${this.callNum}${num.label}`
        }else{
          this.$emit('sendDTMF', num.label)
        }  
      } else {
        this.callNum = `${this.callNum}${num.label}`
      }
    },
    createCall() {
      this.$emit('createCall', this.callNum)
    },
    callTransfer(flag){
      // DashboardではsysInitがないため、sessionStorageから取得
      let tel_num = sessionStorage.getItem('tel_num') || '';
      if(this.callNum && this.callNum != tel_num && this.callNum != this.$store.state.phone.currentCallerNum) {
        this.$emit('callTransfer', flag, this.callNum)
      } else {
        this.$message.closeAll()
        this.$message.warning('请输入正确的电话号')
      }
    },
    addCall(){
      // DashboardではsysInitがないため、sessionStorageから取得
      let tel_num = sessionStorage.getItem('tel_num') || '';
      if(this.callNum && this.callNum != tel_num && this.callNum != this.$store.state.phone.currentCallerNum) {
        this.$emit('addCall', this.callNum)
      } else {
        this.$message.closeAll()
        this.$message.warning('请输入正确的电话号')
      }
    },
    startCallFn(){
      console.log('keyboards vue........... startCallFn')
      if(this.showCallBtn == 1 || (this.callStatus && this.showCallBtn != 2)){
        this.createCall()
      }
      if(this.showCallBtn == 2){
        this.callTransfer(false)
      }
      if(this.showCallBtn == 3) {
        this.addCall()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.keyboards {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  .call_num{
    display: flex;
    margin: 0 50px;
    .backspace {
      color: #4F7BE3;
      line-height: 30px;
      cursor: pointer;
    }
    ::v-deep .el-input__inner{
      text-align: center;
      border: none;
      font-size: 20px;
      height: 30px;
      line-height: 30px;
    }
  }
  .num_box{
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 250px;
    .num{
      margin-top: 15px;
      border: 1px solid #ddd;
      background: #efefef;
      color: #4F7BE3;
      border-radius: 50%;
      height: 60px;
      width: 60px;
      margin: 4px 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      cursor: pointer;
      .num_label{
        font-size:28px;
        margin-bottom: 5px;
      }
      .num_descr{
        color: #aaa;
        font-size:12px;
      }
      &:active, &:hover{
        background: #ddd;
        border-color: #ddd;
        outline: none;
      }
    }
  }
  .call_btns{
    width: 250px;
    padding: 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    .btn_box{
      margin-top: 25px;
      border: 1px solid #ddd;
      background: #efefef;
      color: #4F7BE3;
      border-radius: 50%;
      height: 70px;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      [class*='fa-'] {
        font-size:24px;
        width: auto;
      }
      &:active, &:hover{
        background: #ddd;
        border-color: #ddd;
        outline: none;
      }
      &.call_start{
        border: 1px solid #5D9048;
        background: #5D9048;
        color: #fff;
        &:active, &:hover{
          background: #79b95f;
          border-color: #79b95f;
          outline: none;
        }
      }
    }
  }
  .transfer_btns, .add_call_btns{
    display: flex;
    justify-content: center;
    margin-top: 30px;
    .btn_box{
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 5px;
      min-width: 100px;
      border: 1px solid #ddd;
      background: #efefef;
      padding: 8px 10px;
      border-radius: 5px;
      cursor: pointer;
      color: #4F7BE3;
      .svg-icon{
        margin: 0 5px;
      }
      &:active, &:hover{
        background: #ddd;
        border-color: #ddd;
        outline: none;
      }
    }
    .btn_box + .btn_box {
      margin-left: 10px;
    }
    font-size: 14px;
  }
}
</style>
